// CaseQRCardButton.jsx
import { useRef, useState } from "react";
import QRCode from "qrcode";

const DPI = 300; // print at 300dpi
const W = 1050; // 3.5" * 300
const H = 600; // 2.0" * 300

export default function CaseQRCardButton({
	caseId,
	templateUrl, // e.g. '/assets/card-1050x600.png' or full URL with CORS
	baseUrl, // optional: override domain
	qrBox = { x: 640, y: 110, size: 380 }, // adjust to your blank spot
}) {
	const [busy, setBusy] = useState(false);
	const canvasRef = useRef(null);

	async function generateAndDownload() {
		setBusy(true);
		try {
			const canvas =
				canvasRef.current || document.createElement("canvas");
			const ctx = canvas.getContext("2d");
			canvas.width = W;
			canvas.height = H;

			const url = `${baseUrl || window.location.origin}/cases/${caseId}`;

			// load template
			const tpl = await loadImage(templateUrl);

			// make QR data URL
			const qrDataUrl = await QRCode.toDataURL(url, {
				errorCorrectionLevel: "H",
				margin: 2, // quiet zone
				scale: 8, // generate sharp QR, we’ll scale onto canvas
				color: {
					dark: "#362239", // foreground (QR dots)
					light: "#ffffff", // background
				},
			});
			const qrImg = await loadImage(qrDataUrl);

			// draw
			ctx.clearRect(0, 0, W, H);
			ctx.drawImage(tpl, 0, 0, W, H);
			ctx.drawImage(qrImg, qrBox.x, qrBox.y, qrBox.size, qrBox.size);

			// download
			const a = document.createElement("a");
			a.download = `case-${caseId}-qr-card.png`;
			a.href = canvas.toDataURL("image/png");
			a.click();
		} catch (e) {
			console.error(e);
			alert("Couldn’t generate the QR card. See console for details.");
		} finally {
			setBusy(false);
		}
	}

	return (
		<div>
			<button
				className="button"
				onClick={generateAndDownload}
				disabled={busy}
			>
				<i className="pi pi-qrcode"></i>
				{busy ? "Generating…" : "Download QR Card"}
			</button>
			<canvas ref={canvasRef} style={{ display: "none" }} />
		</div>
	);
}

function loadImage(src) {
	return new Promise((resolve, reject) => {
		const img = new Image();
		// needed if src is a different origin with CORS enabled
		img.crossOrigin = "anonymous";
		img.onload = () => resolve(img);
		img.onerror = reject;
		img.src = src;
	});
}
